const accountStatusEnum = Object.freeze({
  ACTIVE: 'A',
  DISABLED: 'D',
  PENDING: 'P',
  EXPIRED: 'R',
});

export default accountStatusEnum;
